import React from "react";
import Styles from "./Settlement.module.css";

const SettlementFooter = ({
  role,
  status,
  settlementDetails,
  onAction,
  handleClose,
}) => {
  const isReadOnlyConsumer =
    (role === "CONSUMER" || role === "GENERATOR") &&
    ["MAKER", "CHECKER", "PAYMENT"].includes(status);
  const isReadOnlyMaker =
    role === "MAKER" && ["CHECKER", "PAYMENT"].includes(status);
  const isReadOnlyChecker = role === "CHECKER" && status === "PAYMENT";

  if (isReadOnlyConsumer || isReadOnlyMaker || isReadOnlyChecker) return null;

  const approvedCount = settlementDetails.filter((e) => e?.status === "PAYMENT").length;
  const rejectedCount = settlementDetails.filter((e) => e?.status === "RECHECK").length;
  const total = settlementDetails.length;
  const pendingCount = total - approvedCount - rejectedCount;
  const allApproved = total > 0 && approvedCount === total;
  const anyRejected = rejectedCount > 0;
  const allMakerVerified =
    role === "MAKER" &&
    settlementDetails?.every((ele) => ele?.status === "CHECKER");

  const showCheckerProgress = role === "CHECKER" && total > 0;
  const progressPct = total > 0 ? Math.round((approvedCount / total) * 100) : 0;

  return (
    <div className={Styles.foot}>
      {showCheckerProgress && (
        <div className={Styles.footSummary}>
          <div className={Styles.footCounters}>
            <span className={Styles.footCounter}>
              <span className={Styles.footCountDot} style={{ background: "#757575" }} />
              <span className={Styles.footCountNum}>{pendingCount}</span>
              <span className={Styles.footCountLbl}>Pending</span>
            </span>
            <span className={Styles.footDivider} />
            <span className={Styles.footCounter}>
              <span className={Styles.footCountDot} style={{ background: "#2e7d32" }} />
              <span className={Styles.footCountNum} style={{ color: "#2e7d32" }}>
                {approvedCount}
              </span>
              <span className={Styles.footCountLbl}>Approved</span>
            </span>
            <span className={Styles.footDivider} />
            <span className={Styles.footCounter}>
              <span className={Styles.footCountDot} style={{ background: "#c62828" }} />
              <span className={Styles.footCountNum} style={{ color: "#c62828" }}>
                {rejectedCount}
              </span>
              <span className={Styles.footCountLbl}>Rejected</span>
            </span>
          </div>
          <div className={Styles.footProgressWrap}>
            <div
              className={Styles.footProgressBar}
              style={{ width: `${progressPct}%` }}
            />
          </div>
          <span className={Styles.footProgressLbl}>
            {approvedCount} / {total} charges reviewed
          </span>
        </div>
      )}

      <div className={Styles.footActions}>
        <button className={`${Styles.btn} ${Styles.btnGhost}`} onClick={handleClose}>
          Cancel
        </button>

        <div className={Styles.footActionsRight}>
          {(role === "CONSUMER" || role === "GENERATOR") &&
            settlementDetails?.length > 0 && (
              <button
                className={`${Styles.btn} ${Styles.btnPrimary}`}
                onClick={() => onAction("submit")}
              >
                <span className={Styles.btnIcon}>✓</span>
                Submit for Review
              </button>
            )}

          {role === "MAKER" && (
            <button
              className={`${Styles.btn} ${Styles.btnPrimary}`}
              disabled={!allMakerVerified}
              onClick={() => allMakerVerified && onAction("submit")}
              title={!allMakerVerified ? "Verify all charges before submitting" : ""}
            >
              <span className={Styles.btnIcon}>✓</span>
              Submit to Checker
            </button>
          )}

          {role === "CHECKER" && (
            <>
              <button
                className={`${Styles.btn} ${Styles.btnDanger}`}
                disabled={!anyRejected}
                onClick={() =>
                  anyRejected &&
                  onAction(
                    settlementDetails.some((e) => e?.status === "RECHECK")
                      ? "transferToMaker"
                      : "rejectAll",
                  )
                }
                title={!anyRejected ? "Mark at least one charge as rejected first" : ""}
              >
                <span className={Styles.btnIcon}>✕</span>
                Send Back{rejectedCount > 0 ? ` (${rejectedCount})` : ""}
              </button>
              <button
                className={`${Styles.btn} ${Styles.btnSuccess}`}
                disabled={!allApproved}
                onClick={() => allApproved && onAction("payout")}
                title={
                  !allApproved
                    ? `${total - approvedCount} charge(s) still need approval`
                    : ""
                }
              >
                <span className={Styles.btnIcon}>✓</span>
                Approve &amp; Submit
                {total > 0 && (
                  <span className={Styles.btnBadge}>
                    {approvedCount}/{total}
                  </span>
                )}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettlementFooter;
